import { styled } from '@clickcease/cc-client-components-lib'

export const ExplainBoxWrapper = styled('div', {
  position: 'absolute',
  display: 'flex',
  top: '$32',
  height: '66px',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '$6',
  backgroundColor: '$white',
  zIndex: '1',
  borderRadius: '$medium',
  boxShadow: '$card',
})

export const ExplainBoxText = styled('span', {
  fontSize: '$sm',
  fontWeight: '$l',
  color: '$black',
  textAlign: 'center',
})

export const ExplainBoxValue = styled('span', {
  fontSize: '$md',
  fontWeight: '$sb',
  backgroundColor: '$white',
  backgroundImage: '$primaryGradient',
  backgroundSize: '100%',
  '-webkit-background-clip': 'text',
  '-webkit-text-fill-color': 'transparent',
  '-moz-background-clip': 'text',
  '-moz-text-fill-color': 'transparent',
})
